/**
 * A REGRA DO ADIAR — uma só, pros dois lugares que mostram o aviso.
 *
 * O QUE JÁ VENCEU NÃO SE DISPENSA. Só some quando for resolvido: é gente
 * entrando em obra sem documento, não uma notificação. O que está PRA VENCER
 * pode ser silenciado por uma semana — porque incomodar todo dia com o que
 * ainda tem prazo é o jeito mais rápido de treinar a pessoa a ignorar o aviso
 * (e aí ela ignora o vencido também).
 *
 * Extraído de components/AvisoConformidade (14/07) quando a tela Pessoas passou
 * a mostrar o mesmo aviso: se cada uma guardasse a própria chave, adiar num
 * lugar deixaria o outro gritando, e o operador aprenderia que o botão mente.
 */

const CHAVE_ADIADO = "conformidade:adiado-ate";
const UMA_SEMANA = 7 * 86_400_000;

export function estaAdiado(agora: number = Date.now()): boolean {
  try {
    const ate = localStorage.getItem(CHAVE_ADIADO);
    return !!ate && new Date(ate).getTime() > agora;
  } catch {
    // Qualquer erro: MOSTRA. Esconder aviso de segurança por bug de storage é o
    // pior desfecho possível.
    return false;
  }
}

export function adiarUmaSemana(agora: number = Date.now()): void {
  try {
    localStorage.setItem(CHAVE_ADIADO, new Date(agora + UMA_SEMANA).toISOString());
  } catch {
    /* sem localStorage: o aviso continua aparecendo, e tudo bem */
  }
}

/** O motivo do botão desabilitado — vira o `title`, pra dizer POR QUE não dá. */
export const MOTIVO_NAO_DISPENSA =
  "O que já venceu não se dispensa — só sai daqui quando o documento for renovado.";
